import { render, staticRenderFns } from "./PaymentHeader.vue?vue&type=template&id=7972c12c&scoped=true&"
import script from "./PaymentHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHeader.vue?vue&type=style&index=0&id=7972c12c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972c12c",
  null
  
)

export default component.exports